import FormBaseComponent, {OptionalFormBaseComponentState} from "./FormBaseComponent";
export { OptionalFormBaseComponentState, FormBaseComponent };
export default FormBaseComponent;


// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--1!./app/components/FormBaseComponent/index.ts